const Data = [
    {
        name: "Anish Sofat",
        position: "Sponsorship Head",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Akshitha Surkanti",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads21/Akshitha Surkanti.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Eshita Chandwani",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads21/Eshita Chandwani.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Parv Maheshwari",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads21/Parv Maheshwari.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Yogesh Chawla ",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads21/Yogesh Chawla.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
  
    
]

export default Data;